import { Box, Button, Dialog, TextField, Typography } from "@mui/material";
import { AvailabilitySetup, Time } from "lib/features/availability/types";
import { User } from "lib/features/user/types";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DigitalClock } from "@mui/x-date-pickers/DigitalClock";
import ButtonOutline from "common/ButtonOutline";
import dayjs, { Dayjs } from "dayjs";
import { Formik } from "formik";
import { useLazyGetBusinessesQuery } from "lib/features/business/businessService";
import { useGetAllInfluencersQuery } from "lib/features/influencer/influencerService";
import { Item } from "lib/features/item/types";
import { selectUser } from "lib/features/user/userSlice";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import authServices from "services/auth-service";
import { addAvailabilityStyles } from "styles/AvailabilityDirectory/addAvailability.styles";
import { selectRefereeStyles } from "styles/AvailabilityDirectory/selectReferee.styles";
import { updateEndTime } from "util/commonHelper";
import {
  getEndTime,
  getFormattedTime,
  getTimeBetween,
  getUniqueDaysBetweenDates,
} from "util/dateFunctions";
import { getAvatarImageSource, getFullImageSource } from "util/getImageSource";
import CalenderPickerNew from "../../components/CalenderPickerNew";

import {
  selectCustomerDetails,
  selectIsExistingBookingLink,
} from "lib/features/message/messageSlice";
import BlackBinIcon from "../../../../../assets/icons/black_bin.svg";
import BlackPlusIcon from "../../../../../assets/icons/black_plus_icon.svg";
import CheckedMark from "../../../../../assets/icons/checked-mark.svg";
import CheckedRadio from "../../../../../assets/icons/CheckedRadio.svg";
import ClockIcon from "../../../../../assets/icons/clock.svg";
import DeleteIcon from "../../../../../assets/icons/delete-icon.svg";
import SearchIcon from "../../../../../assets/icons/search.svg";
import UncheckedMark from "../../../../../assets/icons/unchecked-mark.svg";
import UnCheckedRadio from "../../../../../assets/icons/UnCheckedRadio.svg";

export interface Duration {
  label: string;
  value: number;
}

interface DetailStepProps {
  itemDetails: Item;
  availabilitySetup: AvailabilitySetup;
  selectedInfluencer: User | undefined;
  setSelectedInfluencer: React.Dispatch<React.SetStateAction<User | undefined>>;
  isEditing: boolean;
  submit: (values: any) => void;
  handleOpenRefereeModal: () => void;
}

type UserOrBusiness = User & {
  business_name?: string;
  business_headline?: string;
  business_id?: number;
  businessImage?: string;
};

export const timeDurationList: Duration[] = [
  {
    label: "No Duration",
    value: 0,
  },
  {
    label: "30 Mins",
    value: 0.5,
  },
  {
    label: "1 Hrs",
    value: 1,
  },
  {
    label: "1 hrs 30 Mins.",
    value: 1.5,
  },
  {
    label: "2 Hrs",
    value: 2,
  },
  {
    label: "2 hrs 30 Mins.",
    value: 2.5,
  },
  {
    label: "3 hrs",
    value: 3,
  },
  {
    label: "3 hrs 30 Mins.",
    value: 3.5,
  },
  {
    label: "4 hrs",
    value: 4,
  },
  {
    label: "4 hrs 30 Mins.",
    value: 4.5,
  },
  {
    label: "5 hrs",
    value: 5,
  },
  {
    label: "5 hrs 30 Mins.",
    value: 5.5,
  },
  {
    label: "6 hrs",
    value: 6,
  },
  {
    label: "6 hrs 30 Mins.",
    value: 6.5,
  },
  {
    label: "7 hrs",
    value: 7,
  },
  {
    label: "7 hrs 30 Mins.",
    value: 7.5,
  },
  {
    label: "8 hrs",
    value: 8,
  },
];

const AvailabilityStepForm = ({
  itemDetails,
  availabilitySetup,
  handleOpenRefereeModal,
  selectedInfluencer,
  setSelectedInfluencer,
  isEditing,
  submit,
}: DetailStepProps) => {
  const [selectedDays, setSelectedDays] = useState<any>();
  const user = useSelector(selectUser);

  const customerDetails = useSelector(selectCustomerDetails);
  console.log("customer details: ", selectedInfluencer)
  const isExistingBookingLink = useSelector(selectIsExistingBookingLink);

  const [showPicker, setShowPicker] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [selectedTime, setSelectedTime] = useState<Dayjs | null>(null);

  const [userData, setUserData] = useState<User>();
  const [showReferees, setShowReferees] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState("");


  const regionId = userData?.regions?.[0]?.region?.id;


  const { data: influencerData, isLoading: isLoadingInfluencers } = useGetAllInfluencersQuery(
    regionId as number,
    { skip: !regionId }
  );


  const [getBusinesses, { data: businessData, isLoading: isLoadingBusinesses }] =
    useLazyGetBusinessesQuery();


  const [combinedData, setCombinedData] = useState<UserOrBusiness[]>([]);
  const [filteredInfluencerData, setFilteredInfluencerData] = useState<UserOrBusiness[]>();
  useEffect(() => {
    const fetchUser = async () => {
      if (user?.id) {
        try {
          const response = await authServices.fetchUser(user.id);
          setUserData(response?.data);
        } catch (error: any) {
          console.error("Error fetching chats:", error?.message);
        }
      }
    };
    fetchUser();
  }, []);


  useEffect(() => {
    getBusinesses(null);
  }, [getBusinesses]);
  useEffect(() => {
    const combined: User[] = [];

    if (influencerData) {
      combined.push(...influencerData);
    }
    if (businessData) {
      const businessUsers = businessData
        .filter((business: any) => business.business_users && business.business_users.length > 0)
        .map((business: any) => {
          const user = business.business_users[0];
          return {
            ...user,
            business_name: business.business,
            business_headline: business.business_headline,
            business_id: business.id,
            businessImage: business.businessImages && business.businessImages.length > 0 ? business.businessImages[0].uri : null,
          };
        });
      combined.push(...businessUsers);
    }

    setCombinedData(combined);
  }, [influencerData, businessData]);
  useEffect(() => {
    if (searchValue.trim() === "") {
      setFilteredInfluencerData(combinedData);
    } else {
      const filteredData = combinedData?.filter((item: UserOrBusiness) => {
        const fullName = `${item?.first_name?.toLowerCase() || ''} ${item?.last_name?.toLowerCase() || ''}`;
        const businessName = item?.business_name?.toLowerCase() || '';
        const searchTerm = searchValue.toLowerCase();

        return fullName.includes(searchTerm) || businessName.includes(searchTerm);
      });
      setFilteredInfluencerData(filteredData);
    }
  }, [searchValue, combinedData]);

  return (
    <Box>
      {!isExistingBookingLink && !customerDetails?.customer_name && (
        <>
          <Typography sx={addAvailabilityStyles.mainHeading}>
            Booking Link Type *{" "}
          </Typography>
          <Typography sx={addAvailabilityStyles.lightDescription}>
            A Public Link allows any of your referral partners to book this on
            the landing page, while a Direct Link generates a shareable booking
            URL intended for one person only.
          </Typography>
        </>
      )}
      <Formik initialValues={availabilitySetup} onSubmit={submit}>
        {({ handleSubmit, values, setFieldValue, handleChange }) =>
          !showReferees ? (
            <>
              {/* Public And Direct Radio Button */}
              {isExistingBookingLink && customerDetails?.customer_name ? (
                <>
                  <Typography sx={addAvailabilityStyles.mediumHeading}>
                    Direct Link
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "15px",
                      fontWeight: "400",
                      color: "#595959",
                    }}
                  >
                    A Direct Link generates a shareable booking URL intended for
                    the customer and will not be displayed publicly.
                  </Typography>
                </>
              ) : (
                <>
                  <Button
                    onClick={() => {
                      setFieldValue("private", false);
                      setSelectedInfluencer(undefined);
                      setFieldValue("referee_id", null);
                    }}
                    sx={addAvailabilityStyles.radioButton}
                  >
                    {values.private === false ? (
                      <img src={CheckedRadio} alt="checked-radio" />
                    ) : (
                      <img src={UnCheckedRadio} alt="unchecked-radio" />
                    )}
                    <Typography sx={addAvailabilityStyles.radioButtonText}>
                      Public
                    </Typography>
                  </Button>
                  <Button
                    onClick={() => setFieldValue("private", true)}
                    sx={addAvailabilityStyles.radioButton}
                  >
                    {values.private === true ? (
                      <img src={CheckedRadio} alt="checked-radio" />
                    ) : (
                      <img src={UnCheckedRadio} alt="unchecked-radio" />
                    )}
                    <Typography sx={addAvailabilityStyles.radioButtonText}>
                      Direct Link
                    </Typography>
                  </Button>
                </>
              )}

              {/* Select Date and Time */}

              <Typography sx={addAvailabilityStyles.mediumHeading}>
                Select Date and Time
              </Typography>

              {/* Start Date */}
              <Box>
                <Typography sx={addAvailabilityStyles.mainHeading}>
                  Start Date *
                </Typography>

                <CalenderPickerNew
                  handleDateSelect={(start_date: Date) => {
                    setFieldValue("start_date", start_date);
                    if (!values.end_date || values.end_date < start_date) {
                      setFieldValue("end_date", start_date);
                      setSelectedDays([]);
                    }
                    const daysBetweenTwoDates: Array<string> =
                      getUniqueDaysBetweenDates(start_date, values.end_date);
                    if (daysBetweenTwoDates.length === 0) {
                      const dayName = start_date.toLocaleDateString("en-US", {
                        weekday: "long",
                      });
                      setSelectedDays([{ day: dayName, selected: true }]);
                      setFieldValue("days", [dayName]);
                    } else {
                      setFieldValue("days", daysBetweenTwoDates);
                      setSelectedDays(
                        daysBetweenTwoDates.map((day) => ({
                          day,
                          selected: true,
                        }))
                      );
                    }
                  }}
                  selectedDate={values.start_date}
                />
              </Box>

              {/* End Date */}
              {!values.private && (
                <Box>
                  <Typography sx={addAvailabilityStyles.mainHeadingV2}>
                    End Date *
                  </Typography>

                  <CalenderPickerNew
                    handleDateSelect={(end_date: Date) => {
                      setFieldValue("end_date", end_date);

                      // Ensure end_date is not before start_date
                      if (!values.start_date || end_date < values.start_date) {
                        setFieldValue("start_date", end_date);
                        setSelectedDays([]);
                      }

                      const daysBetweenTwoDates: Array<string> =
                        getUniqueDaysBetweenDates(values.start_date, end_date);

                      if (daysBetweenTwoDates.length === 0) {
                        const dayName = end_date.toLocaleDateString("en-US", {
                          weekday: "long",
                        });
                        setSelectedDays([{ day: dayName, selected: true }]);
                        setFieldValue("days", [dayName]);
                      } else {
                        setSelectedDays(
                          daysBetweenTwoDates.map((day) => ({
                            day,
                            selected: true,
                          }))
                        );
                        setFieldValue("days", daysBetweenTwoDates);
                      }
                    }}
                    selectedDate={values.end_date}
                  />
                </Box>
              )}

              {/* Available Days */}
              <Box>
                <Typography sx={addAvailabilityStyles.mainHeadingV2}>
                  Days repeating *
                </Typography>

                <Box sx={addAvailabilityStyles.daysRepeatingContainer}>
                  {selectedDays?.map((item: any, index: any) => (
                    <Button
                      key={index}
                      sx={addAvailabilityStyles.checkBoxContainer}
                      onClick={() => {
                        if (selectedDays?.length == 1) {
                          return;
                        }
                        const selectedDayIndex = values.days.indexOf(item?.day);
                        if (selectedDayIndex !== -1) {
                          values.days.splice(selectedDayIndex, 1);
                        } else {
                          values.days.push(item.day);
                        }

                        setSelectedDays((prevDays: any) =>
                          prevDays.map((day: any, i: any) =>
                            i === index
                              ? { ...day, selected: !day.selected }
                              : day
                          )
                        );
                      }}
                    >
                      {item.selected ? (
                        <img
                          src={CheckedMark}
                          alt="checked-mark"
                          width={18}
                          height={18}
                        />
                      ) : (
                        <img
                          src={UncheckedMark}
                          alt="un-checked-mark"
                          width={18}
                          height={18}
                        />
                      )}
                      <Typography sx={addAvailabilityStyles.repeatDayText}>
                        {item.day.slice(0, 2)}
                      </Typography>
                    </Button>
                  ))}

                  {selectedDays && selectedDays?.length > 1 && (
                    <Typography sx={addAvailabilityStyles.unCheckDays}>
                      Uncheck the days that your item is not available
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Start Time And Duration */}
              {values.times.map((time, index) => (
                <Box sx={{ marginTop: "10px" }} key={index}>
                  <Box>
                    <Box sx={addAvailabilityStyles.timeDuraionBox}>
                      {/* Start Time */}
                      <Box sx={addAvailabilityStyles.halfBox}>
                        <Typography sx={addAvailabilityStyles.mainHeadingV2}>
                          Start Time*
                        </Typography>

                        <Button
                          sx={addAvailabilityStyles.startTimeButon}
                          onClick={() => {
                            setActiveIndex(index);
                            setSelectedTime(dayjs(time.start_time));
                            setShowPicker(true);
                          }}
                        >
                          <Typography sx={addAvailabilityStyles.startTimeText}>
                            {getFormattedTime(time.start_time)}
                          </Typography>
                        </Button>

                        {/* Modal with DigitalClock */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Dialog
                            open={showPicker}
                            onClose={() => setShowPicker(false)}
                            PaperProps={{
                              sx: { overflow: "hidden" },
                            }}
                          >
                            <Box sx={{ p: 3 }}>
                              <Typography
                                variant="h6"
                                sx={addAvailabilityStyles.setTimeText}
                              >
                                Set Time
                              </Typography>

                              <Box sx={addAvailabilityStyles.timeContainer}>
                                <DigitalClock
                                  value={selectedTime}
                                  onChange={(newValue: Dayjs | null) =>
                                    setSelectedTime(newValue)
                                  }
                                  ampm={true}
                                  timeStep={15}
                                />
                              </Box>

                              <Box
                                sx={addAvailabilityStyles.timeButtonContainer}
                              >
                                <Button
                                  variant="outlined"
                                  onClick={() => setShowPicker(false)}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    if (!selectedTime) return;
                                    setFieldValue(
                                      `times[${activeIndex}].start_time`,
                                      selectedTime.toDate()
                                    );

                                    if (
                                      values.times[activeIndex].end_time <
                                      selectedTime.toDate()
                                    ) {
                                      const endTime = getEndTime(
                                        selectedTime.toDate(),
                                        values.times[activeIndex].duration
                                      );
                                      setFieldValue(
                                        `times[${activeIndex}].end_time`,
                                        endTime
                                      );
                                    }

                                    setShowPicker(false);
                                  }}
                                >
                                  Confirm
                                </Button>
                              </Box>
                            </Box>
                          </Dialog>
                        </LocalizationProvider>
                      </Box>

                      {/* Duration Dropdown */}
                      <Box sx={addAvailabilityStyles.halfBox}>
                        <Typography sx={addAvailabilityStyles.mainHeadingV2}>
                          Quantity *
                        </Typography>

                        <TextField
                          value={time.quantity?.toString() || ""}
                          onChange={(e) => {
                            if (/^\d{0,4}$/.test(e.target.value)) {
                              const qty = e.target.value
                                ? parseInt(e.target.value, 10)
                                : "";
                              setFieldValue(`times[${index}].quantity`, qty);
                            }
                          }}
                          sx={addAvailabilityStyles.textField}
                        />
                      </Box>
                    </Box>

                    {/* Ending Time */}
                    {!values.private && (
                      <Box sx={addAvailabilityStyles.endingTimeBox}>
                        <Box
                          sx={addAvailabilityStyles.endingTimeImageContainer}
                        >
                          <img src={ClockIcon} alt="clock-icon" />
                        </Box>
                        <Typography sx={addAvailabilityStyles.endingAtText}>
                          Ending at{" "}
                          {moment
                            .utc(
                              updateEndTime(
                                time.start_time,
                                itemDetails?.itemDetails?.[0]?.duration
                              )
                            )
                            .tz("America/New_York")
                            .format("hh:mm A")}
                        </Typography>
                      </Box>
                    )}

                    {/* Remove Button */}
                    {index !== 0 && !isEditing && (
                      <>
                        <Button
                          sx={addAvailabilityStyles.removeButton}
                          onClick={() => {
                            const updatedTimes = values.times.filter(
                              (_, i) => i !== index
                            );
                            setFieldValue("times", updatedTimes);
                          }}
                        >
                          <img src={DeleteIcon} alt="delete-icon" />
                          <Typography
                            sx={addAvailabilityStyles.removeButtonText}
                          >
                            Remove
                          </Typography>
                        </Button>
                      </>
                    )}
                    <Box sx={addAvailabilityStyles.horizontalLine} />
                  </Box>
                </Box>
              ))}

              {/* Another Start Time */}
              {!values.private && (
                <Box>
                  <Typography
                    sx={addAvailabilityStyles.anotherTimeText}
                    onClick={() => {
                      const timeNew = new Date();
                      timeNew.setHours(12, 0, 0, 0);
                      const time: Time = {
                        start_time: timeNew,
                        end_time: timeNew,
                        duration: getTimeBetween(timeNew, timeNew),
                        quantity: itemDetails?.itemDetails?.[0]?.capacity,
                      };
                      const previousTimes: Time[] = values.times;
                      previousTimes.push(time);
                      setFieldValue("times", previousTimes);
                    }}
                  >
                    + Add Another Start Time
                  </Typography>
                </Box>
              )}

              {values.private === true &&
                !isExistingBookingLink &&
                !customerDetails?.customer_name && (
                  <Box>
                    <Typography sx={addAvailabilityStyles.AddRefereeText}>
                      Add Referee *
                    </Typography>
                    <Typography sx={addAvailabilityStyles.AddRefereeAlertText}>
                      Add a Referee from your Connections list.{" "}
                    </Typography>
                    {selectedInfluencer ? (
                      <Box
                        key={itemDetails?.id}
                        sx={addAvailabilityStyles.card}
                      >
                        <Box sx={addAvailabilityStyles.imageContainer}>
                          <img
                            src={selectedInfluencer?.businessImage ? getFullImageSource(selectedInfluencer?.businessImage) : getAvatarImageSource(selectedInfluencer)}
                            style={addAvailabilityStyles.image}
                            alt="user-icon"
                          />
                        </Box>
                        <Box sx={addAvailabilityStyles.detailsContainer}>
                          <Box sx={addAvailabilityStyles.textContainer}>
                            <Typography sx={addAvailabilityStyles.name}>
                              {
                                selectedInfluencer?.business_name ? selectedInfluencer?.business_name : selectedInfluencer?.first_name + " " + selectedInfluencer?.last_name?.[0] + "."
                              }
                            </Typography>

                            <Typography sx={addAvailabilityStyles.company}>
                              {selectedInfluencer?.influencer_type?.type}
                            </Typography>
                            <Typography sx={addAvailabilityStyles.location}>
                              {selectedInfluencer?.regions?.[0]?.region?.region}
                            </Typography>
                          </Box>
                          <Box
                            onClick={() => {
                              setSelectedInfluencer(undefined);
                              setFieldValue("referee_id", null);
                            }}
                            sx={addAvailabilityStyles.plusIconButton}
                          >
                            <img src={BlackBinIcon} alt="bin-icon" />
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      <Box sx={addAvailabilityStyles.SignInOuter}>
                        <ButtonOutline
                          title={"+ Add Referee"}
                          onAction={() => {
                            setShowReferees(true);
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                )}

              {/* Button */}
              <Button
                variant="contained"
                sx={addAvailabilityStyles.greenButton}
                disabled={
                  values.private &&
                  !values.referee_id &&
                  !isExistingBookingLink &&
                  !customerDetails?.customer_name
                }
                onClick={() => {
                  handleSubmit();
                }}
              >
                {values?.private
                  ? "Review and Share Booking link"
                  : "Review/Edit and Publish"}
              </Button>
            </>
          ) : (
            <Box>
              <Box sx={selectRefereeStyles.searchContainer}>
                <img
                  src={SearchIcon}
                  width={20}
                  height={20}
                  style={selectRefereeStyles.searchIcon}
                  alt="search-icon"
                />
                <TextField
                  placeholder="Search"
                  sx={selectRefereeStyles.searchField}
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </Box>

              <Box sx={selectRefereeStyles.scrollContainer}>
                {(isLoadingInfluencers || isLoadingBusinesses) ? (
                  <Typography sx={selectRefereeStyles.noInfluencerText}>
                    Loading...
                  </Typography>
                ) : (
                  <>
                    {filteredInfluencerData?.map((item: UserOrBusiness) => (
                      <Box key={item?.id} sx={[selectRefereeStyles.card]}>
                        <Box sx={selectRefereeStyles.imageContainer}>
                          {item?.businessImage ?
                            <img
                              src={getFullImageSource(item.businessImage)}
                              style={addAvailabilityStyles.image}
                              alt="business-icon"
                            /> :
                            <img
                              src={getAvatarImageSource(item)}
                              style={addAvailabilityStyles.image}
                              alt="user-icon"
                            />}
                        </Box>
                        <Box sx={selectRefereeStyles.detailsContainer}>
                          <Box sx={selectRefereeStyles.textContainer}>
                            <Typography sx={selectRefereeStyles.name}>
                              {item?.business_name
                                ? item.business_name
                                : `${item?.first_name} ${item?.last_name?.[0]}.`
                              }
                            </Typography>

                            <Typography sx={selectRefereeStyles.company}>
                              {item?.business_headline || item?.influencer_type?.type}
                            </Typography>
                            <Typography sx={selectRefereeStyles.location}>
                              {item?.regions?.[0]?.region?.region}
                            </Typography>
                          </Box>
                          <Box
                            onClick={() => {
                              setSelectedInfluencer(item);
                              setFieldValue("referee_id", item.id);
                              setShowReferees(false);
                            }}
                            sx={selectRefereeStyles.plusIconButton}
                          >
                            <img src={BlackPlusIcon} alt="black-plus" />
                          </Box>
                        </Box>
                      </Box>
                    ))}
                    {filteredInfluencerData?.length === 0 && (
                      <Typography sx={selectRefereeStyles.noInfluencerText}>
                        No Record
                      </Typography>
                    )}
                  </>
                )}
              </Box>
            </Box>
          )
        }
      </Formik>
    </Box>
  );
};

export default AvailabilityStepForm;